import { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import GCAutocompleteCheckboxFixSizeUid from "../VendorDiscontinueChangeApprove/GCAutocompleteCheckboxFixSizeUid";
import {  Head_Set } from "./ItemListApproveSlice";
import { vRdxUserInfo } from "../../Redux/roStore";
import {
  getReasonAttribute,
  ILSTCRA_Confirm_Summary,
} from "../../Server/ApiV2";
import ApproveModal from "./ApproveModal";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import Breadcrumbs from "./BreadCrumbs";
import { getStatusStyleV1 } from "../../Utility/Utilitys";
import { DataGridPro, useGridApiRef,gridRowIdsSelector } from "@mui/x-data-grid-pro";
import { useLocation } from "react-router-dom";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

export default function ItemListApprove() {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const vRdxUserInfoObj = vRdxUserInfo();
  const queryParams = useLocation();
  const apiRef = useGridApiRef();
  const dispatch = useDispatch();
  const pageType = queryParams.search.split("type=")[1];
  const status = ["All", "Enter", "Post"];

  const vRdxuserLoc = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
   const initialState = {
      dateFrom: moment().startOf("month").toDate(),
      dateTo: moment().toDate(),
      location: vRdxuserLoc?.map((item) => item.Uid),
      status: "All",
    };
  const [filterObj, setFilterObj] = useState(initialState);
  const [open, setOpen] = useState(false);
  const [rejectTypeArr, setrejectTypeArr] = useState([]);
  const [row, setRow] = useState([]);

  const fonLoad = async () => {
    var obj = {
      FromDate: moment(filterObj?.dateFrom).format("MM/DD/YYYY"),
      ToDate: moment(filterObj?.dateTo).format("MM/DD/YYYY"),
      Location: Array.isArray(filterObj?.location)
        ? filterObj?.location.join(",")
        : filterObj?.location || "",
      Status: filterObj?.status || "",
      UserCd: vRdxUserInfoObj?.UserID || "",
      Type: pageType,
    };
    const sumFilterRes = await ILSTCRA_Confirm_Summary(obj);
    if (sumFilterRes?.status === 200) {
      setRow(sumFilterRes?.data?.recordset);
    }
  };

  const handleRowClick = (params) => {
    dispatch(
      Head_Set({
        A_Transid: params.row.A_Transid,
        A_Date: params.row.A_Date,
        A_Location: params.row.A_Location,
        Loc_Name: params.row.Loc_Name,
        A_Narration: params.row.A_Narration,
        A_Status: params.row.A_Status,
        ApproveStatus: params.row.ApproveStatus,
        CreatedBy: params.row.CreatedBy,
        CreatedDt: params.row.CreatedDt,
        ConfirmBy: params.row.ConfirmBy,
        ConfirmDt: params.row.ConfirmDt,
        A_Vendor: params.row.A_Vendor,
        A_LocationcsvName: params.row.A_LocationcsvName,
        A_Status_CM: params.row.A_Status_CM,
        A_Status_PM: params.row.A_Status_PM,
      })
    );
    setOpen(true);
  };
  const getReasonTypeAttribute = async () => {
    try {
      const res = await getReasonAttribute();
      if (res?.status === 200) {
        setrejectTypeArr(res?.data?.recordset || []);
      }
    } catch (error) {}
  };
   const handleExport = () => {
  apiRef.current.exportDataAsCsv({
    getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
    includeHeaders: true,
    utf8WithBom: true,
  });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  useEffect(() => {
    getReasonTypeAttribute();
  }, []);

  useEffect(() => {
    setFilterObj((prev) => ({
      ...prev,
      ...initialState,
    }));
    setRow([])
  }, [pageType]);


  return (
    <>
    < div className="div-container">
      <Box sx={{ mt: { xs: 2, md: 0 } }}>
        <Breadcrumbs pageType={pageType} />
      </Box>
      <Grid
        container
        spacing={{ xs: 1.5, md: 1 }}
        sx={{ alignItems: { xs: "flex-end" }, mt: { xs: 1, sm: 0 } }}
      >
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <Typography>From Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName={"dateFrom"}
            xValue={filterObj?.dateFrom}
            xOnChange={(val) => {
              setFilterObj((prev) => ({
                ...prev,
                dateFrom: val?.$d ?? val,
              }));
            }}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <Typography>To Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName={"dateTo"}
            xValue={filterObj?.dateTo}
            xOnChange={(val) => {
              setFilterObj((prev) => ({
                ...prev,
                dateTo: val?.$d ?? val,
              }));
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4.5} lg={4}>
          <Typography>Location</Typography>
          <GCAutocompleteCheckboxFixSizeUid
            options={vRdxuserLoc ?? []}
            xValue={filterObj?.location}
            setValue={(updatedObj) => {
              setFilterObj((prev) => ({
                ...prev,
                location: updatedObj,
              }));
            }}
            objName="location"
            label=""
            placeholder="Search Location"
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2.5} lg={1.5}>
          <Typography>Status</Typography>
          <FormControl fullWidth>
            <Select
              size="small"
              value={filterObj?.status}
              name="status"
              onChange={(e) => {
                setFilterObj((prev) => ({
                  ...prev,
                  status: e.target.value,
                }));
              }}
            >
              {status.map((obj) => (
                <MenuItem key={obj} value={obj}>
                  {obj}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          xs={12}
          sm={9}
          md={12}
          lg={3.5}          
        >
          <Box display="flex" justifyContent="flex-end" flexWrap="wrap" gap={1}>
            <Button variant="contained" size="small" onClick={fonLoad}>
              Load
            </Button>
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      <Box
         sx={{
          height: { xs: "54vh", sm: "70vh", md: "74vh", lg: "80vh" },
          marginTop: 1,
        }}
      >
        <DataGridPro
          apiRef={apiRef}
          rowHeight={30}
          headerHeight={40}
          rows={row}
          getRowId={(v) => v.A_Transid}
          columns={[
            {
              field: "A_Transid",
              headerName: "Transid",
              width: 70,
              align: "center",
            },
            {
              field: "A_Date",
              headerName: "Date",
              width: 95,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "Loc_Name",
              headerName: "Trans Location",
              width: 120,
            },
            {
              headerName: "LPO Group",
              field: "LPOGruppenName",
              width: 120,
            },
            {
              field: "A_Narration",
              headerName: "Narration",
              minWidth: 150,
              hide: vMediaQuery,
            },
            {
              field: "A_Status",
              headerName: "Status",
              width: 75,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_Status_CM",
              headerName: "CM Status",
              width: 80,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_Status_PM",
              headerName: "PM Status",
              width: 75,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "ApproveStatus",
              headerName: "Appr Status",
              width: 90,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "CreatedBy",
              headerName: "Created By",
              width: 110,
            },
            {
              field: "CreatedDt",
              headerName: "Created Date",
              width: 95,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_CM_By",
              headerName: "Appr By CM",
              width: 110,
            },
            {
              field: "A_CM_Dt",
              headerName: "CM Appr Date",
              width: 100,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_PM_By",
              headerName: "Appr By PM",
              width: 110,
            },
            {
              field: "A_PM_Dt",
              headerName: "PM Appr Date",
              width: 95,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "ApprovedBy",
              headerName: "Confirm By",
              width: 110,
            },
            {
              field: "ApproveDt",
              headerName: "Confirm Date",
              width: 95,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
          ]}
          hideFooter={true}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
          }}
          onRowDoubleClick={(params) => {
            handleRowClick(params);
          }}
        />
      </Box>
      <CycleCustomModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        vMediaQuery={vMediaQuery}
        xMediaQuery={vMediaQuery}
        title={`Item Listing Approve ${pageType}`}
        children={
          <ApproveModal
            handleClose={() => setOpen(false)}
            fonLoad={fonLoad}
            rejectTypeArr={rejectTypeArr}
            type={pageType}
          />
        }
      />
      </div>
    </>
  );
}
